var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$slots.default)?_c('div',{staticClass:"d-card",class:{'is-disabled': _vm.disabled, 'is-clipped': _vm.clipped, 'is-compact': _vm.compact}},[_vm._t("default"),_vm._v(" "),(_vm.disabled)?_c('div',{staticClass:"d-card-overlay"}):_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }